export default "__VITE_ASSET__q1NK6jaG__"